import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  hover = false
}: CardProps) {
  const hoverStyles = hover ? 'hover:shadow-xl hover:-translate-y-1' : '';
  return <div className={`bg-white rounded-xl shadow-lg transition-all duration-300 ${hoverStyles} ${className}`} data-id="element-226">
      {children}
    </div>;
}